
$(document).ready(function() {      
  
  
var indexPage = $('#index_page').length;
var aboutPage = $('#about_us').length;
var contactPage = $('#contact').length;
var productPage = $('#product_inside').length;
 var productPageContent = $('#product_inside_content').length;
var productlistingPage = $('#product_listing').length;
  var faqPage = $('#faq_page').length;
var footersec =$('#footer_sec').length;
  var quizPage =$('#quiz_1').length;
  var plansPage = $("#plans").length;

//====================================functions====================================
var transferHeight = function (source, destination) {
    var sourceH = $(source).outerHeight();
    $(destination).outerHeight(sourceH);
}

var equalHeight = function (target) {
    var setHeight = 0;
    $(target).each(function () {
        var getH = $(this).outerHeight();
        if (setHeight < getH) {
            setHeight = getH;
        }
    });
    $(target).outerHeight(setHeight);
}

$(window).on('load', function () {
    var winW = $(window).outerWidth();
    if (winW > 767) {
        equalHeight('.shop_product');
        equalHeight('.also_product');
        equalHeight('.good_product');
    }
});
  
    $(window).on("scroll", function() {
    if($(window).scrollTop() > 50) {
        $(".site-header__mobile-nav").addClass("active");
    } else {
        //remove the background property so it comes transparent again (defined in your css)
       $(".site-header__mobile-nav").removeClass("active");
    }
});
  

    
  if (footersec == 1) {
  
  $(".footer_set > a").on("click", function() {
                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");
                    $(this)
                        .siblings(".footer_content")
                        .slideUp(200);
                    $(".footer_set > a i")
                        .removeClass("fa-minus")
                        .addClass("fa-plus");
                } else {
                    $(".footer_set > a i")
                        .removeClass("fa-minus")
                        .addClass("fa-plus");
                    $(this)
                        .find("i")
                        .removeClass("fa-plus")
                        .addClass("fa-minus");
                    $(".footer_set > a").removeClass("active");
                    $(this).addClass("active");
                    $(".footer_content").slideUp(200);
                    $(this)
                        .siblings(".footer_content")
                        .slideDown(200);
                }
            });
  }
  

//====================================listing-page====================================

  
//====================================product-page====================================  
  if (productPage == 1) {
    


  
  	var prSlider = $('.main-pr-wrapper').slick({
  			slidesToShow: 1,
  			slidesToScroll: 1,
//             asNavFor: '.product-single__thumbnails',
  			arrows: false,
      autoplay: true,
       dots:true,
      adaptiveHeight: true,
      infinite: true,
       rows:0
		 });
//       	$('.product-single__thumbnails').slick({
//           	slidesToShow: 4,
//   			slidesToScroll: 1,
//             asNavFor: '.main-pr-wrapper',
// //           	centerMode: true,
// //   			focusOnSelect: true,
//           infinite:false,
//           rows:0
//       	});
      
  
//       	var imageSlides = [];
//       	$.each(prSlider.slick("getSlick").$slides, function(index, element) {
//           var imageSlideurl = "https:" + $(element).find('.product-single__media').attr("data-original");  
//           imageSlides.push(imageSlideurl.split('?')[0]);
//       	});
      	
//       	document.addEventListener("variantSlideChange", function(pvar){
//           //console.log(pvar.detail.variant);
//           var currentSlideIndex = prSlider.slick("slickCurrentSlide");
//           var currentVariantImage = pvar.detail.variant.featured_image ? pvar.detail.variant.featured_image.src : "";
//           if(currentVariantImage != "") {
//             var variantIndex;
//             $.each(imageSlides, function(index, el) {
//               if(el == currentVariantImage.split('?')[0]) {
//                 variantIndex = index;
//               }
//             });
            
//             if(typeof variantIndex !== "undefined" && variantIndex != currentSlideIndex) {
//             	prSlider.slick("slickGoTo", variantIndex);
//           	}
//           }
//         });
      
//       function changeSlide(currentFlow) {
//         var currentSlideIndex = prSlider.slick("slickCurrentSlide");
//         var variantIndex;
//         var flowResult = spVariants.filter(function(data, index) {
//           return data['option1'] == currentFlow && data['featured_image'] != null;
//         });
//         $.each(imageSlides, function(index, el) {
//           if(el == flowResult[0].featured_image.src.split('?')[0]) {
//             variantIndex = index;
//           }
//         });
//         if(typeof variantIndex !== "undefined" && variantIndex != currentSlideIndex) {
//           prSlider.slick("slickGoTo", variantIndex);
//         }
//       }
    
  

    
  }

  
  if (faqPage == 1) {
  		  
            $('.tab-a').click(function() {
                $(".tab").removeClass('tab-active');
                $(".tab[data-id='" + $(this).attr('data-id') + "']").addClass("tab-active");
                $(".tab-a").removeClass('active-a');
                $(this).parent().find(".tab-a").addClass('active-a');
            });
       

        // accordion script 
  
            $(".set > a").on("click", function() {
                if ($(this).hasClass("active")) {
                    $(this).removeClass("active");
                    $(this)
                        .siblings(".content")
                        .slideUp(200);
                    $(".set > a i")
                        .removeClass("fa-minus")
                        .addClass("fa-plus");
                } else {
                    $(".set > a i")
                        .removeClass("fa-minus")
                        .addClass("fa-plus");
                    $(this)
                        .find("i")
                        .removeClass("fa-plus")
                        .addClass("fa-minus");
                    $(".set > a").removeClass("active");
                    $(this).addClass("active");
                    $(".content").slideUp(200);
                    $(this)
                        .siblings(".content")
                        .slideDown(200);
                }
            });
        
  }
   

  if (plansPage == 1) {
     
		// SmartWizard initialize
		$('#smartwizard').smartWizard({
			selected: 0,
			theme: 'default',
			contentURL: 'plans.php',
			autoAdjustHeight: false,
			enableURLhash: false,
			keyboardSettings: {
				keyNavigation: true,
				justified: true,
				keyLeft: [74], // J key code
				keyRight: [75] // K key code
			},
			toolbarSettings: {
				toolbarPosition: 'bottom', // none, top, bottom, both
				toolbarButtonPosition: 'center', // left, right, center
				showNextButton: true, // show/hide a Next button
				showPreviousButton: true, // show/hide a Previous button
				toolbarExtraButtons: [] // Extra buttons to show on toolbar, array of jQuery input/buttons elements
			},
			anchorSettings: {
				markDoneStep: true, // add done css
				markAllPreviousStepsAsDone: true, // When a step selected by url hash, all previous steps are marked done
				removeDoneStepOnNavigateBack: true, // While navigate back done step after active step will be cleared
				enableAnchorOnDoneStep: false // Enable/Disable the done steps navigation
			}
		});
		$('#get_Started').on('click', function () {
			$('.wizard_main').fadeIn();
			$('.landing_base').fadeOut();

			$('.toolbar').addClass('button_section');
			$('.toolbar .btn').addClass('btn_style');


		});
		$(".toolbar .sw-btn-next").prop('disabled', true);
		var prevBtn = $('#smartwizard').smartWizard("prev");
    	var prevState = 0
        
    	$(".sw-btn-prev").click(function() {
          var stepIndex = $('#smartwizard').smartWizard("getStepIndex");
          console.log(stepIndex, prevState)
          if (stepIndex == 0 && prevState == 1) prevState = 0
          $('#smartwizard').smartWizard("goToStep", prevState);
        })
        
        $("#plan2").click(function() {
          $('#smartwizard').smartWizard("goToStep", 1);
        	prevState = 1
            
        })
    
		$('.start_id').click(function () {

			$('.wizard_main').fadeIn();
			$('.landing_base').fadeOut();
			$('.toolbar').addClass('button_section');
			$('.toolbar .btn').addClass('btn_style');

			console.log($(this).attr('data-select-plan'));
// 			$($(this).attr('data-select-plan')).trigger('click');
            if($(this).attr('data-select-plan')=='#plan1') {
              $('#smartwizard').smartWizard("goToStep", 2);
              prevState = 0
            }
		});
    
		$('#banner_direct').click(function () {

			$('.wizard_main').fadeIn();
			$('.landing_base').fadeOut();
			$('.toolbar').addClass('button_section');
			$('.toolbar .btn').addClass('btn_style');

			// console.log($(this).attr('data-select-plan'));
			// $($(this).attr('data-select-plan')).trigger('click');
			$('#smartwizard').smartWizard("goToStep", 0);



		});

		// to enable next button for
		$('#smartwizard .tab-content input[type="radio"]').change(function () {
			$(".toolbar .sw-btn-next").prop('disabled', false);
          console.log($(this).attr('data-to-show-text'));

		})

		// Initialize the leaveStep event
		var txtWizard = $('.wizradTxt');
		$("#smartwizard").on("leaveStep", function (e, anchorObject, currentStepIndex, nextStepIndex, stepDirection) {
			// $(".toolbar .sw-btn-next").prop('disabled', true);




			// for next button enable or dissble
			if ($('#smartwizard .tab-content .tab-pane:nth-child(' + (nextStepIndex + 1) + ') input[type="radio"]:checked').length) {
				$(".toolbar .sw-btn-next").prop('disabled', false);

			} else {
				$(".toolbar .sw-btn-next").prop('disabled', true);
			}

			// for chnging the title of steps to selected option
			// if ($('#smartwizard .tab-content .tab-pane:nth-child(' + (nextStepIndex) + ') input[type="radio"]:checked').length) {
			// 	$(this).parent('.box_inner').find('.box_head h4').text() == txtWizard;
			// }
			if (stepDirection == 'forward') {
				var getSelectedText = $('#smartwizard .tab-content .tab-pane:nth-child(' + (nextStepIndex) + ') input[type="radio"]:checked');

				// console.log(getSelectedText.attr('data-to-show-text'), ' this is text');
				// txtWizard.text(getSelectedText.attr('data-to-show-text'));
				$('#smartwizard .nav li:nth-child(' + (nextStepIndex) + ') a .wizradTxt').text(getSelectedText.attr('data-to-show-text'))

			}


		});


		$('.onecheck_box input[type="checkbox"]').click(function () {
			var inputValue = $(this).attr("value");
			$("." + inputValue).toggle();
			$(this).parent('.onecheck_box').siblings('img').toggleClass('img_scale');
		});


		const minus = $('.quantity__minus');
		const plus = $('.quantity__plus');
		const input = $('.quantity__input');
		minus.click(function (e) {
			e.preventDefault();
			var thisValue = $(this).siblings(input);
			var value = thisValue.val();
			if (value > 0) {
				value--;
			}
			thisValue.val(value);
		});

		plus.click(function (e) {
			e.preventDefault();
			var thisValue = $(this).siblings(input);
			var value = thisValue.val();
			value++;
			thisValue.val(value);
		})

var winW = $(window).outerWidth();
//alert(winW);
		if (winW < 769) {
			$('.product_name, .fa').on('click', function () {
              
				$(this).parent('.product_cat').siblings('.radio_sec, .quantity_sec').slideToggle();
				$(this).siblings('.fa').toggleClass('fa-minus');
				$(this).siblings('.product_list').toggle();
			});

		} else {
			equalHeight('.hiw_slider .flex_body');
		}
    if (winW < 768){
    equalHeight('.hiw_slider .flex_body');
    }


		$(".hiw_slider").slick({
			dots: true,
			arrows: false,
			autoplay: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,


			speed: 1500,
			autoplaySpeed: 3000,
			responsive: [{
				breakpoint: 992,
				settings: {
					adaptiveHeight: true
				}
			},{
				breakpoint: 767,
				settings: {
					adaptiveHeight: true
				}
			}]

		});


	}
  
  
  
  
  
   if (indexPage == 1) {  
  
  var winW = $(window).outerWidth();
var winH = $(window).outerHeight();
  
         
  	$(".also_section").slick({
		rows: 0,
		dots: !0,
		arrows: !1,
		autoplay: !0,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		pauseOnHover: !1,
		centerMode: !0,
		centerPadding: 0,
		autoplaySpeed: 2500,
		speed: 1e3,
		prevArrow: '<button class="slide-arrow prev-arrow buzzfeed_left_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/left_arrow.png" class="img-responsive"></button>',
		nextArrow: '<button class="slide-arrow next-arrow buzzfeed_right_arrow"><img src="//cdn.shopify.com/s/files/1/0578/9715/6765/t/2/assets/right_arrow.png" class="img-responsive "></button>',
		responsive: [{
			breakpoint: 1200,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 1024,
			settings: {
				arrows: !1,
				centerMode: !0,
				centerPadding: "0px",
				slidesToShow: 2,
				slidesToScroll: 1
			}
		}, {
			breakpoint: 480,
			settings: {
				autoplaySpeed: 2500,
				arrows: !1,
				dots: !0,
				autoplay: !0,
				slidesToShow: 2,
				slidesToScroll: 1,
				centerMode: !1,
				speed: 1e3,
				centerPadding: "0px",
				cssEase: "linear"
			}
		}]
	})
     
     
  if (winW < 768) {
        $('.slider_on_mobile').slick({
            dots: false,
            infinite: true,
            arrows: true,
            speed: 300,
          	prevArrow: '<button class="slide-arrow prev-arrow coll_left_arrow"><img src="https://cdn.shopify.com/s/files/1/0578/9715/6765/files/left_arrow_6afc4b56-7b86-4ab8-9369-ac8c025c46a9.png?v=1630395725" class="img-responsive"></button>',
            nextArrow: '<button class="slide-arrow next-arrow coll_right_arrow"><img src="https://cdn.shopify.com/s/files/1/0578/9715/6765/files/right_arrow_b458c26a-5240-43e0-afd7-880a19b98f82.png?v=1630395725" class="img-responsive "></button>',
//             autoplay: true,
//             autoplaySpeed: 2000,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }
    
   }
  
  
  $("#increment").click(function() {
                var str = $("#Quantity-product-template").val();
                if (str >= 0) {
                    str++;
                    $('#Quantity-product-template').val(str);
                }
            });

            $("#decrement").click(function() {
                var str = $("#Quantity-product-template").val();
                if (str > 0) {
                    str--;
                    $('#Quantity-product-template').val(str);
                }
            });
  
  
    
  $("#increment").click(function() {
                var str = $("#Quantity-product-accessories-template").val();
                if (str >= 0) {
                    str++;
                    $('#Quantity-product-accessories-template').val(str);
                }
            });

  $("#decrement").click(function() {
                var str = $("#Quantity-product-accessories-template").val();
                if (str > 0) {
                    str--;
                    $('#Quantity-product-accessories-template').val(str);
                }
            });
  
  
 
  
  
  
         
          function scrollDown() {
   window.location.href = '#reviews';
            
            
 }

  
  if($('.template-product').length) {
    var productID = $('.product-template__container').data('product-id');
    fetch('https://gumption-singapore.recurpay.com/api/storefront/product/' + productID  + '/plans.json').then(response => response.json()).then(data => {
      recurData = data.data.plans;
      console.log(recurData);
    });
  }
  
   });


     


 $(document).ready(function()  {
   
  
  $(".related-product-sec").slick({
  			slidesToShow: 2,
  			slidesToScroll: 1,
    	autoplay: true,
            infinite: true,
  			arrows: false,
       dots:true,
    autoplaySpeed: 2500,
		      rows:0,
    responsive: [{
    	breakpoint: 480,
      	settings: {
        	slidesToShow: 1,
          arrows: false
        }
    }]
		 });
   
   
   $(".selector-wrapper .varient-set1 .variant_img").on({
                      
                      
						click: function(){
                                                    
                          var img = $(".selector-wrapper .varient-set1 .variant_img");
                          
                        var i;
                        for (i = 0; i < img.length; i++) {
                          $(img[i]).parents('.varient-set1').removeClass('active');
                          
                        }
						$(this).parents('.varient-set1').addClass('active');
                          
                         
             
						}  
					});
  
//   shashikant
  
    if (winW < 767) {
  $( "#mobile-price" ).insertAfter( ".review_section" );
   }
   
  
  $( ".selector-wrapper.js:nth-child(1)" ).after( "<div id='test-desc'></div>" );

  $( ".short-desc" ).appendTo( "#test-desc" );
  
 // shashikant done
  
  
  
  
  
  
      $(".selector-wrapper .varient-set1:nth-child(1)").hasClass('active');
    $(".selector-wrapper .varient-set1:nth-child(1)").addClass('active');
                 setInterval(function(){
      // alert("Hello! I am an alert box!!");
    //if()
//  if ($(".selector-wrapper .varient-set1:nth-child(1)").hasClass('active')) {
//       $(".short-desc .short_desc_txt:nth-child(1)").show();
//     $(".short-desc .short_desc_txt:nth-child(2)").hide();
//     $(".short-desc .short_desc_txt:nth-child(3)").hide();
//    $(".short-desc.short_desc_txt:nth-child(4)").hide();
//    $(".short-desc .short_desc_txt:nth-child(5)").hide();
//    $(".short-desc .short_desc_txt:nth-child(6)").hide();
// }     
      
//  if ($(".selector-wrapper .varient-set1:nth-child(2)").hasClass('active')) {
//     $(".short-desc .short_desc_txt:nth-child(1)").hide();
//     $(".short-desc .short_desc_txt:nth-child(2)").show();
//     $(".short-desc .short_desc_txt:nth-child(3)").hide();
//    $(".short-desc .short_desc_txt:nth-child(4)").hide();
//    $(".short-desc .short_desc_txt:nth-child(5)").hide();
//    $(".short-desc .short_desc_txt:nth-child(6)").hide();
// } 
      
      
//  if ($(".selector-wrapper .varient-set1:nth-child(3)").hasClass('active')) {
//     $(".short-desc .short_desc_txt:nth-child(1)").hide();
//     $(".short-desc .short_desc_txt:nth-child(2)").hide();
//     $(".short-desc .short_desc_txt:nth-child(3)").show();
//    $(".short-desc .short_desc_txt:nth-child(4)").hide();
//    $(".short-desc .short_desc_txt:nth-child(5)").hide();
//    $(".short-desc .short_desc_txt:nth-child(6)").hide();
     
// } 
                   
                   //sss
                   
                  //  $(".short-desc .short_desc_txt").hide();
                   
                      
                   if($(".input-container.varient-set1:nth-child(1) .each_pack input").prop('checked') == true){
                     
     $(".short-desc .short_desc_txt:nth-child(2)").addClass("ishow");
                         $(".short-desc .short_desc_txt:nth-child(3)").removeClass("ishow");
                         $(".short-desc .short_desc_txt:nth-child(4)").removeClass("ishow");
}
                     if($(".input-container.varient-set1:nth-child(2) .each_pack input").prop('checked') == true){
      $(".short-desc .short_desc_txt:nth-child(3)").addClass("ishow");
       $(".short-desc .short_desc_txt:nth-child(2)").removeClass("ishow");
                         $(".short-desc .short_desc_txt:nth-child(4)").removeClass("ishow");
}
                     if($(".input-container.varient-set1:nth-child(3) .each_pack input").prop('checked') == true){
    $(".short-desc .short_desc_txt:nth-child(4)").addClass("ishow");
      $(".short-desc .short_desc_txt:nth-child(2)").removeClass("ishow");
                         $(".short-desc .short_desc_txt:nth-child(3)").removeClass("ishow");
}
                   
                   
//                    $('.varient-set1').click(function(){
  
//                      if($('.input-container.varient-set1:nth-child(1) .each_pack input[type="radio"]:checked').is(':checked')) {
// 		//alert("111"); 
                       
                     
//                        $(".short-desc .short_desc_txt:nth-child(2)").addClass("ishow");
//                          $(".short-desc .short_desc_txt:nth-child(3)").removeClass("ishow");
//                          $(".short-desc .short_desc_txt:nth-child(4)").removeClass("ishow");
                      
// 	}
  
// 	else if($('.input-container.varient-set1:nth-child(2) .each_pack input[type="radio"]:checked').is(':checked')) {
// 		  $(".short-desc .short_desc_txt:nth-child(3)").addClass("ishow");
//        $(".short-desc .short_desc_txt:nth-child(2)").removeClass("ishow");
//                          $(".short-desc .short_desc_txt:nth-child(4)").removeClass("ishow");
// 	}
  
//    else if($('.input-container.varient-set1:nth-child(3) .each_pack input[type="radio"]:checked').is(':checked')) {
// 	  $(".short-desc .short_desc_txt:nth-child(4)").addClass("ishow");
//       $(".short-desc .short_desc_txt:nth-child(2)").removeClass("ishow");
//                          $(".short-desc .short_desc_txt:nth-child(3)").removeClass("ishow");
// 	}
                     
                     
// 	else{
// 		//alert('44');
// 	}
  
// });
                   
                       
                   
  
   },100) 
  
                 
                 
                 
  
});



        $(document).ready(function() {
            //save boolean
            var pause = false;
            //save items that with number
            var item = $('.select-item');
            //save blocks
            var block = $('.bg-block');
            //variable for counter
            var k = 0;


            //interval function works only when pause is false
            setInterval(function() {
                if (!pause) {
                    var $this = item.eq(k);

                    if (item.hasClass('active')) {
                        item.removeClass('active');
                    };
                    block.removeClass('active').eq(k).addClass('active');
                    $this.addClass('active');
                    //increase k every 1.5 sec
                    k++;
                    //if k more then number of blocks on page
                    if (k >= block.length) {
                        //rewrite variable to start over
                        k = 0;
                    }
                }
                //every 1.5 sec
            }, 150);

          
//           var url1 = window.location.href = 'https://gumptioncoffee.sg/collections/shop/beans';
          
         
          	
//             url1.window.location.replace('https://gumptioncoffee.sg/');
          
          
          
          
        });

